<template>
    <div class="economy-learning">
        
        <content-switch
        :items="switchItems"
        :selectedItem="selectedItem"
        :counts="counts"
        @selectItem="handleSelectItem($event)" />

        <revenue-and-costs v-show="selectedItem === 'revenueAndCosts'" />
        <ebitda v-show="selectedItem === 'ebitda'" />
        <compare v-if="selectedItem === 'compare'" />
        <potential v-show="selectedItem === 'potential'" />
        <keyFigures v-show="selectedItem === 'keyFigures'" />
        <materials v-show="selectedItem === 'materials'" />
        <all-invoices v-show="selectedItem === 'allInvoices'" @finishedLoading="updateCount('allInvoices', $event)" />

    </div>
</template>

<script>
import revenueAndCosts from './learning/revenueAndCosts.vue'
import ebitda from './learning/ebitda.vue'
import compare from './learning/compare.vue'
import potential from './learning/potential.vue'
import keyFigures from './learning/keyFigures.vue'
import materials from './learning/materials.vue'

export default {
    components: {
        revenueAndCosts,
        ebitda,
        compare,
        potential,
        keyFigures,
        materials
    },
    data () {
        return {
            selectedItem: 'ebitda',
            counts: {
                EconomyOperationsUnbilledProjects: null,
                EconomyOperationsExceededPayments: null,
                allInvoices: null
            },
            switchItems: [
                {
                    name: 'EBITDA',
                    slug: 'ebitda',
                    dTooltip: 'economy.ebitda'
                },
                {
                    name: 'Værdikæde',
                    slug: 'revenueAndCosts'
                },
                {
                    name: 'Nøgletal',
                    slug: 'keyFigures'
                },
                {
                    name: 'Vareforbrug',
                    slug: 'materials'
                },
                {
                    name: 'Alle fakturaer og kreditnotaer',
                    slug: 'allInvoices'
                }
                /* {
                    name: 'Virksomhedens potentiale',
                    slug: 'potential',
                    comingsoon: false
                }, */
            ]
        }
    },
    methods: {
        updateCount (slug, event) {
            this.counts[slug] = event
        },
        handleSelectItem (item) {
            this.selectedItem = item
        }
    },
    mounted () {
        this.$store.state.view = 'learning'
        if (this.$store.state.config.availableDepartments.length > 2) {
            this.switchItems.splice(4, 0, {name: 'Sammenlign afdelinger', slug: 'compare'})
        }
    }
}
</script>



// WEBPACK FOOTER //
// learning.vue?dc40fca2